// extracted by mini-css-extract-plugin
export default {"container":"MyDebateRoomList_container__XdvAb","wrapper":"MyDebateRoomList_wrapper__PSpD6","divUp":"MyDebateRoomList_divUp__dUm-K","pageTitle":"MyDebateRoomList_pageTitle__vOFU3"};